import type { FocusEvent } from 'react';

function isTextFilterControl(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false;
  if (el.closest('.ant-select, .ant-picker, .ipc-date-range')) return false;
  return Boolean(
    el.closest(
      'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]), textarea, .ant-input-affix-wrapper',
    ),
  );
}

function fieldRoot(el: HTMLElement): HTMLElement | null {
  return el.closest(
    '.ant-input-affix-wrapper, .ipc-filter-bar__search, .ipc-filter-bar__field, .ipc-filter-bar__field--range',
  );
}

function isSameTextField(from: EventTarget | null, to: EventTarget | null): boolean {
  if (!(from instanceof HTMLElement) || !(to instanceof HTMLElement)) return false;
  const a = fieldRoot(from);
  const b = fieldRoot(to);
  return a != null && a === b;
}

function isAntOverlay(el: EventTarget | null): boolean {
  return el instanceof HTMLElement && Boolean(
    el.closest('.ant-select-dropdown, .ant-picker-dropdown, .ant-picker-panel-container'),
  );
}

function isFilterAction(el: EventTarget | null): boolean {
  return el instanceof HTMLElement && Boolean(el.closest('.ipc-filter-actions'));
}

/** 筛选栏内文本框失焦时提交；点清除按钮、下拉浮层、查询/重置不算离开。 */
export function handleFilterTextBlur(
  event: FocusEvent<HTMLElement>,
  onSubmit: () => void,
): void {
  if (!isTextFilterControl(event.target)) return;
  if (isSameTextField(event.target, event.relatedTarget)) return;
  if (isAntOverlay(event.relatedTarget)) return;
  if (isFilterAction(event.relatedTarget)) return;
  onSubmit();
}
